<school-header-ui [title]='headingtext'></school-header-ui>